export class UserInfo {
    public username: string;
    public userId: number;
    public marketId: number;
    public userType: string;
    public email: string;
    public permissions: Array<string>;
    public permissionList = {};

    constructor(response: any) {
        this.username = response.username;
        this.userId = response.userId;
        this.marketId = response.marketId;
        this.userType = response.userType;
        this.email = response.email;
        this.permissions = response.permissions || [];
        this.permissions.forEach(function (permission) {
            this.permissionList[permission] = true;
        }, this);
    }

    hasPermission(permissionKey: string): boolean {
        return this.permissionList[permissionKey] === true;
    }
}